import { getCookie, setCookie } from "./utils/cookies";

/**
 * Storage interface for type safety
 */
export interface StorageData {
  [key: string]: any;
}

/**
 * Saves data to storage with fallback to cookies if localStorage fails
 * @param key - The storage key
 * @param value - The value to store
 * @returns void
 */
export function saveStorageData(key: string, value: StorageData): void {
  const jsonValue = JSON.stringify(value);

  try {
    localStorage.setItem(key, jsonValue);
  } catch (error) {
    console.warn('localStorage not available, falling back to cookies:', error);
    setCookie(key, jsonValue);
  }
}

/**
 * Retrieves data from storage with fallback to cookies if localStorage fails
 * @param key - The storage key
 * @returns The stored data or empty object if not found
 */
export function getStorageData(key: string): StorageData {
  let data: string | null = null;

  try {
    data = localStorage.getItem(key);
  } catch (error) {
    console.warn('localStorage not available, falling back to cookies:', error);
    data = getCookie(key);
  }

  try {
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error('Failed to parse stored data:', error);
    return {};
  }
}